"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RoRo API
 * This documents RoRo APIs for handling public facing App needs
 *
 * The version of the OpenAPI document: 0.0.43
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var runtime_1 = require("../runtime");
/**
* @export
* @enum {string}
*/
var UserProfileGenderEnum;
(function (UserProfileGenderEnum) {
    UserProfileGenderEnum["Male"] = "MALE";
    UserProfileGenderEnum["Female"] = "FEMALE";
})(UserProfileGenderEnum = exports.UserProfileGenderEnum || (exports.UserProfileGenderEnum = {}));
function UserProfileFromJSON(json) {
    return UserProfileFromJSONTyped(json, false);
}
exports.UserProfileFromJSON = UserProfileFromJSON;
function UserProfileFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'firstName': !runtime_1.exists(json, 'firstName') ? undefined : json['firstName'],
        'lastName': !runtime_1.exists(json, 'lastName') ? undefined : json['lastName'],
        'phoneNumber': !runtime_1.exists(json, 'phoneNumber') ? undefined : json['phoneNumber'],
        'nationalId': !runtime_1.exists(json, 'nationalId') ? undefined : json['nationalId'],
        'email': !runtime_1.exists(json, 'email') ? undefined : json['email'],
        'registered': !runtime_1.exists(json, 'registered') ? undefined : json['registered'],
        'birthDate': !runtime_1.exists(json, 'birthDate') ? undefined : (json['birthDate'] === null ? null : new Date(json['birthDate'])),
        'gender': !runtime_1.exists(json, 'gender') ? undefined : json['gender'],
    };
}
exports.UserProfileFromJSONTyped = UserProfileFromJSONTyped;
function UserProfileToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'firstName': value.firstName,
        'lastName': value.lastName,
        'phoneNumber': value.phoneNumber,
        'nationalId': value.nationalId,
        'email': value.email,
        'registered': value.registered,
        'birthDate': value.birthDate === undefined ? undefined : (value.birthDate === null ? null : value.birthDate.toISOString()),
        'gender': value.gender,
    };
}
exports.UserProfileToJSON = UserProfileToJSON;
